// save image https://stackoverflow.com/questions/62576196/how-to-extract-the-detected-faces-from-face-api-js


// draw on canvas
//https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Applying_styles_and_colors
// https://progressivewebninja.com/how-to-pass-multiple-values-in-react-context/

import React, { useState, useEffect, useContext, useRef } from 'react';
import { debugdiv, useMountEffect, ReadingsContext } from '../ODevice';


//const ReadingsContext = React.createContext("counter")

export const SinusDemoScaling = {
  timescale:1,
  max_stream_1:1024,
  max_stream_2:1024
}; 

function SinusDemo2() {
  const [debugvisible, setDebugvisible] = useState(true);
  const functionname ='SinusDemo2';
  const refDebugDiv = useRef();

    // Only run once while after mounting
    useMountEffect(()=>{
      console.log( functionname  + '  is loaded');
      if (debugvisible) {
        refDebugDiv.current.style.display = 'unset';
      } else {
        refDebugDiv.current.style.display = 'none';
      }
  });

  const handleChangeChkDebug = event =>{
    console.log('clicked');
    if (event.target.checked) {
        console.log('✅ Checkbox is checked');
        refDebugDiv.current.style.display = 'unset';
      } else {
        console.log('⛔️ Checkbox is NOT checked');
        refDebugDiv.current.style.display = 'none';
      }
      setDebugvisible(debugvisible => !debugvisible);
    };

    const [counter1, setCounter1] = useState(0);
    const [counter2, setCounter2] = useState(0);

    const [milliseconds, setMilliSeconds] = useState(0);
    const [simulation_stream_1,setSimulation_stream_1] = useState(0);
    const [simulation_stream_2,setSimulation_stream_2] = useState(0);
    const [stream_1,setStream_1] = useState(0);
    const [stream_2,setStream_2] = useState(0);

    let context = useContext(ReadingsContext);
    let readings =[...context.readings]; 

    useEffect(() => {
      const interval = setInterval(() => {
        setMilliSeconds(milliseconds => milliseconds + 1);
      //  setIsSimulation_stream_1(Math.sin(milliseconds));
      //  setIsSimulation_stream_2(Math.cos(milliseconds));
      }, 1);
      return () => clearInterval(interval);
    }, []);

    useEffect(() => {
      function processDemoData(){
        setSimulation_stream_1(() => Math.sin(milliseconds/100));
        setSimulation_stream_2(() => Math.cos(milliseconds/100));
        setStream_1(() => Math.round(simulation_stream_1 * SinusDemoScaling.max_stream_1))
        setStream_2(() => Math.round(simulation_stream_2 * SinusDemoScaling.max_stream_2))
        
        var data = {milliseconds, stream_1, stream_2, simulation_stream_1,simulation_stream_2};
        

        if (readings.lenght >=10){
          readings.shift();
        } 

        readings.push(data);

        context.lastReading=data;
        context.readings = readings;
      }
      processDemoData()

      
      //setState([...readings.readings, readings.lastReading]);
      
      //readings.concat(data);
      
      
      //time = milliseconds;
      //stream1 = milliseconds;
      //stream2 = milliseconds;
      
      //console.log(milliseconds);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [milliseconds]); // <- add the milliseconds variable here


    return(
      
        <ReadingsContext.Provider value={{ counter1, setCounter1, counter2, setCounter2, milliseconds, setMilliSeconds, readings: [], lastReading: {}}}>
        <div>
            <div  style={debugdiv}>
                <input type="checkbox" defaultChecked={debugvisible} onChange={ handleChangeChkDebug } />&nbsp;
                <b>{ functionname }</b> 
            </div>
            <div ref={refDebugDiv} >
            </div>
        </div>
        
        </ReadingsContext.Provider>
       
    )
}

export default SinusDemo2;
export { ReadingsContext };

